

export default function getTokenCookieName({ tenantCode, sandbox }) {
    const sessionTokenName = 'X-SessionToken' + (sandbox ? "-sandbox-" : "")  + (tenantCode ? "-" + tenantCode : "");
    return sessionTokenName
}